<div class="audio-panel flex flex-column overflow-auto text-left" style="max-height: 75vh">
   <!-- Waveform Section -->
   <div class="flex flex-column align-items-center gap-3">
      <p-skeleton
         *ngIf="isWaveformLoading()"
         height="100px"
         width="100%"
         class="w-full"
         borderRadius="12px"
         styleClass="mb-2"
      ></p-skeleton>
      <div
         class="waveform-wrapper p-3 w-full"
         [style.display]="isWaveformLoading() ? 'none' : 'block'"
         [style.overflow]="isWaveformLoading() ? 'hidden' : 'visible'"
      >
         <div #waveformContainer style="height: 80px"></div>
         <div #timelineContainer style="width: 100%; height: 20px"></div>
      </div>

      <!-- Playback Controls -->
      <div class="flex flex-row align-items-center justify-content-center gap-3 mt-2 w-full">
         <div class="flex-1">
            <a [href]="selectedAudioUrl()" download="call_audio.wav">
               <p-button icon="pi pi-download" [severity]="'secondary'" [label]="'Descargar audio'"></p-button>
            </a>
         </div>
         <div class="flex flex-row gap-2 align-items-center">
            <p-button icon="pi pi-step-backward" (click)="skipBackward(5)" text></p-button>
            <p-button
               size="large"
               [icon]="waveSurfer?.isPlaying() ? 'pi pi-pause' : 'pi pi-play'"
               (click)="togglePlayPause()"
               [rounded]="true"
               styleClass="margin"
            ></p-button>
            <p-button icon="pi pi-step-forward" (click)="skipForward(5)" text></p-button>
         </div>

         <div class="flex-1 gap-1 flex justify-content-end">
            <p-button
               label="0.5x"
               (click)="setSpeed(0.5)"
               [text]="playbackRate !== 0.5"
               severity="secondary"
            ></p-button>
            <p-button label="1x" (click)="setSpeed(1)" [text]="playbackRate !== 1" severity="secondary"></p-button>
            <p-button label="2x" (click)="setSpeed(1.5)" [text]="playbackRate !== 1.5" severity="secondary"></p-button>
         </div>
      </div>
   </div>

   <p-divider></p-divider>

   <div class="call-info-container bg-indigo-50 border-round p-3 gap-2">
      <span class="text-indigo-700 font-semibold">{{ 'DATA.MODULES.OUTBOUNDCALL.DETAILS' | translate }}</span>

      <div class="call-info-grid mt-3 ml-2">
         <div class="call-info-item" *ngIf="call?.id">
            <div class="p-3 bg-indigo-100 border-round-lg">
               <i class="pi pi-hashtag text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.CALL_ID' | translate }}</span>
               <span class="value">{{ call?.externalId }} </span>
            </div>
         </div>

         <div class="call-info-item" *ngIf="call?.phoneNumber">
            <div class="p-3 bg-indigo-100 border-round-lg">
               <i class="pi pi-phone text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.PHONE_NUMBER' | translate }}</span>
               <span class="value">{{ call?.phoneNumber }}</span>
            </div>
         </div>

         <div class="call-info-item">
            <div class="p-3 bg-indigo-100 border-round-lg">
               <i class="pi pi-clock text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.DURATION' | translate }}</span>
               <span class="value">{{ call?.duration }}s</span>
            </div>
         </div>

         <div class="call-info-item">
            <div class="p-3 bg-indigo-100 border-round-lg">
               <i class="pi pi-calendar text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.DATETIME' | translate }}</span>
               <span class="value">{{ call?.createdAt | timezoneDate: true }}</span>
            </div>
         </div>

         <div class="call-info-item">
            <div class="p-3 bg-indigo-100 border-round-lg">
               <i class="pi pi-user-minus text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.CLOSED_BY' | translate }}</span>
               <span class="value">{{ call?.closedBy ?? '-' }}</span>
            </div>
         </div>

         <div class="call-info-item">
            <div class="p-3 bg-indigo-100 border-round-lg">
               <i class="pi pi-arrow-right-arrow-left text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.TRANSFERRED' | translate }}</span>
               <span class="value">{{ call?.transferred ? 'Sí' : 'No' }}</span>
            </div>
         </div>

          <div class="call-info-item">
            <div class="p-3 bg-indigo-100 border-round-lg">
               <i class="pi pi-arrow-right-arrow-left text-indigo-700 text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.RESULT_CONV' | translate }}</span>
               <span class="value">{{ call?.conversationResult }}</span>
            </div>
         </div>
      </div>
   </div>

   <p-divider></p-divider>

   <div class="flex flex-column gap-2 bg-blue-50 border-round p-3">
      <span class="text-blue-700 font-semibold mb-2">{{ 'DATA.MODULES.OUTBOUNDCALL.RESUME' | translate }}</span>
      <div class="text-600 ml-2" *ngFor="let line of structuredSummary">• {{ line }}</div>
   </div>
   <p-divider></p-divider>

   <div *ngIf="call && call.tags" class="tags-container border-round p-3 gap-2">
         <span class="text-700 font-semibold">{{ 'DATA.MODULES.OUTBOUNDCALL.TAGS' | translate }}</span>

      <div class="flex flex-wrap gap-3 mt-3 ml-2">
         <div
            class="tag-card flex align-items-center gap-2 p-2 pr-3 border-round bg-bluegray-50 shadow-1"
            *ngFor="let tag of call?.tags ?? {} | keyvalue"
         >
            <div class="p-2 bg-white border-round-lg">
               <i class="pi pi-tag text-lg"></i>
            </div>
            <div class="text-column">
               <span class="label text-800 font-semibold">{{ tag.key | titlecase }}</span>
               <span class="value text-600">{{ tag.value }}</span>
            </div>
         </div>
      </div>
   </div>
</div>
